export const initializeFocus = () => {
    const element = document.querySelector("#header-title");
    if (element) (element as HTMLElement).focus();
};

export const setFocus = (selector: string) => {
    const element = document.querySelector(selector);
    if (element) (element as HTMLElement).focus();
};
